<template>
  <div class="info__header">
    <button class="info__header__trigger" @click="toggleImage" role="button">
      {{ isCard ? 'Zum gelben Schein' : 'Zur Scheckkarte' }}<IconChevronRight aria-hidden="true" />
    </button>
    <button
      aria-label="Info schließen"
      class="info__header__close"
      role="button"
      @click="closeInfo"
      v-if="isMobile"
      title="Schließen"
    >
      <IconClose aria-hidden="true" />
    </button>
  </div>
  <hr />
  <div class="info__body">
    <img
      :src="require(`@/assets/images/${isCard ? 'cards' : 'certificates'}/${type}.svg`)"
      :alt="getAltText(isCard, type)"
    />
  </div>
</template>

<script>
import IconChevronRight from '@/components/icons/IconChevronRight.vue'
import IconClose from '@/components/icons/IconClose.vue'
import { mapGetters } from 'vuex'

const vehicleCertificateAltText = {
  card: {
    brand:
      'Rückseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code D1 für die Marke ist hervorgehoben.',
    category:
      'Rückseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code J für die Klasse/Fahrzeugart ist hervorgehoben.',
    engine:
      'Rückseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code P3 für die Antriebsart ist hervorgehoben.',
    fin: 'Rückseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code E für die Fahrzeug-Identifikationsnummer (FIN) ist hervorgehoben.',
    firstName:
      'Vorderseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code C1.2 für den Vornamen ist hervorgehoben.',
    initialRegistration:
      'Vorderseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code B für die Erstzulassung ist hervorgehoben.',
    lastName:
      'Vorderseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code C1.1 für den Nachnamen ist hervorgehoben.',
    licensePlate:
      'Vorderseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code A für das Kennzeichen ist hervorgehoben.',
    model:
      'Vorderseite einer Zulassungsbescheinigung im Scheckkartenformat; das Feld mit dem Code D3 für die Handelsbezeichnung ist hervorgehoben.',
  },
  certificate: {
    brand:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code D1 für die Marke ist hervorgehoben.',
    category:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code J für die Klasse/Fahrzeugart ist hervorgehoben.',
    engine:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code P3 für die Antriebsart ist hervorgehoben.',
    fin: 'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code E für die Fahrzeug-Identifikationsnummer (FIN) ist hervorgehoben.',
    firstName:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code C1.2 für den Vornamen ist hervorgehoben.',
    initialRegistration:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code B für die Erstzulassung ist hervorgehoben.',
    lastName:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code C1.1 für den Nachnamen ist hervorgehoben.',
    licensePlate:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code A für das Kennzeichen ist hervorgehoben.',
    model:
      'Zulassungsbescheinigung als Papierdokument; das Feld mit dem Code D3 für die Handelsbezeichnung ist hervorgehoben.',
  },
}

export default {
  components: { IconChevronRight, IconClose },
  emits: ['closeInfo'],
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isCard: true,
    }
  },
  computed: {
    ...mapGetters(['isMobile']),
  },
  methods: {
    toggleImage(e) {
      e.preventDefault()
      e.stopPropagation()
      this.isCard = !this.isCard
    },
    closeInfo(e) {
      e.preventDefault()
      e.stopPropagation()
      this.$emit('closeInfo')
    },
    getAltText(isCard, type) {
      const altText = isCard
        ? vehicleCertificateAltText.card[type]
        : vehicleCertificateAltText.certificate[type]

      return altText || type
    },
  },
}
</script>

<style lang="scss">
.info {
  &__header {
    display: flex;
    justify-content: space-between;
    padding: 16px;

    &__trigger {
      @include flex-center-align;
      color: $color-text-secondary;
      cursor: pointer;
    }

    &__close {
      cursor: pointer;
    }
  }

  &__body {
    @include flex-center-justify;
    padding: 16px;

    img {
      max-width: 100%;
    }
  }
}
</style>
